/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Explorer_Assignment_Email_Failed_ToastInputs */

const en_explorer_assignment_email_failed_toast = /** @type {(inputs: Explorer_Assignment_Email_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not send email: ${i?.error}`)
};

const fr_explorer_assignment_email_failed_toast = /** @type {(inputs: Explorer_Assignment_Email_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossible d'envoyer l'e-mail : ${i?.error}`)
};

const de_explorer_assignment_email_failed_toast = /** @type {(inputs: Explorer_Assignment_Email_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`E-Mail konnte nicht gesendet werden: ${i?.error}`)
};

const it_explorer_assignment_email_failed_toast = /** @type {(inputs: Explorer_Assignment_Email_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile inviare l'email: ${i?.error}`)
};

const ru_explorer_assignment_email_failed_toast = /** @type {(inputs: Explorer_Assignment_Email_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось отправить письмо: ${i?.error}`)
};

const es_explorer_assignment_email_failed_toast = /** @type {(inputs: Explorer_Assignment_Email_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo enviar el correo: ${i?.error}`)
};

const zh_cn2_explorer_assignment_email_failed_toast = /** @type {(inputs: Explorer_Assignment_Email_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`无法发送邮件：${i?.error}`)
};

const ja_explorer_assignment_email_failed_toast = /** @type {(inputs: Explorer_Assignment_Email_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`メールを送信できませんでした: ${i?.error}`)
};

const hi_explorer_assignment_email_failed_toast = /** @type {(inputs: Explorer_Assignment_Email_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ईमेल नहीं भेजा जा सका: ${i?.error}`)
};

const pt_pt2_explorer_assignment_email_failed_toast = /** @type {(inputs: Explorer_Assignment_Email_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível enviar o e-mail: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Could not send email: {error}" |
*
* @param {Explorer_Assignment_Email_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_assignment_email_failed_toast = /** @type {((inputs: Explorer_Assignment_Email_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Assignment_Email_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_assignment_email_failed_toast(inputs)
	if (locale === "de") return de_explorer_assignment_email_failed_toast(inputs)
	if (locale === "it") return it_explorer_assignment_email_failed_toast(inputs)
	if (locale === "ru") return ru_explorer_assignment_email_failed_toast(inputs)
	if (locale === "es") return es_explorer_assignment_email_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_assignment_email_failed_toast(inputs)
	if (locale === "ja") return ja_explorer_assignment_email_failed_toast(inputs)
	if (locale === "hi") return hi_explorer_assignment_email_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_assignment_email_failed_toast(inputs)
	return en_explorer_assignment_email_failed_toast(inputs)
});